import { API_URL_TRAINING_PLANS, API_URL_TRAINING_WISHES } from 'constants/api'
import { API_TRAININGS } from 'constants/api-v2'
import type { LoaderFunctionArgs } from 'react-router-dom'
import type QueryClient from 'services/query'

export const loadTraining =
  (client: QueryClient, url: string) =>
  async ({ params, request }: LoaderFunctionArgs) => {
    const { id } = params
    const locationUrl = new URL(request.url)
    const queryParams = locationUrl.pathname.includes(`/catalog/training/${id}`)
      ? 'groups[]=trainings:list:recycling-prerequisite'
      : ''

    let training = null
    try {
      training = await client.get(`${url}/${id}?${queryParams}`)
    } catch (e: any) {
      if (e.response.status === 404) {
        throw new Response('', { status: 404 })
      }
      throw new Error(e)
    }

    return training
  }

export const loadTrainingAndWish =
  (client: QueryClient) =>
  async ({ params }: LoaderFunctionArgs) => {
    const { id, wishId } = params

    let training = null
    let wish = null
    let trainingPlans = []

    try {
      ;[training, wish, trainingPlans] = await Promise.all([
        id ? client.get(`${API_TRAININGS}/${id}`) : Promise.resolve(null),
        wishId ? client.get(`${API_URL_TRAINING_WISHES}/${wishId}`) : Promise.resolve(null),
        id ? client.get(API_URL_TRAINING_PLANS) : Promise.resolve({ items: [] }),
      ])
    } catch (e: any) {
      if (e.response.status === 404) {
        throw new Response('', { status: 404 })
      }
    }

    return { training, wish, trainingPlans: trainingPlans.items }
  }
